$.onmount("[data-component='coupon-forms/select-duration-type']", function() {
  var $el = $(this)

  function selectDurationType() {
    var durationType = $el.val()
    var isLimitedPeriod = durationType === "limited_period"

    $("#duration-period").toggleClass("d-none", !isLimitedPeriod)
    $("#duration-period-unit").toggleClass("d-none", !isLimitedPeriod)
  }

  $el.on("change", selectDurationType)
})
